<template>
  <v-container style="width:100%; height:100%">
    <v-row no-gutters class="d-flex">
      <template>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end flex-nowrap label-text"
            :style="textSize"
            flat
          >
            Scenarios:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ coursesCount }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end flex-nowrap label-text"
            :style="textSize"
            flat
          >
            Time Spent:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ formatDuration(timeSpent) }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end flex-nowrap label-text"
            :style="textSize"
            flat
          >
            Attempts:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ attempts }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end flex-nowrap label-text"
            :style="textSize"
            flat
          >
            Interactions:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ interactions }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end flex-nowrap label-text"
            :style="textSize"
            flat
          >
            Last Interaction:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ lastInteraction }}
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { getDuration, capitalizeFirstLetter } from '../Constants'
import moment from 'moment'

export default {
  props: {
    agent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timeSpent: null,
      attempts: 0,
      interactions: 0,
      lastInteraction: null,
      coursesCount: 0
    }
  },
  computed: {
    textSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'font-size: 0.5rem;'
          break
        case 'md':
          return 'font-size: 0.63rem;'
          break
        case 'lg':
          return 'font-size: 0.77rem;'
          break
        case 'xl':
          return 'font-size: 0.87rem;'
          break
        default:
          return 'font-size: 0.87rem;'
      }
    }
  },
  methods: {
    formatDuration(date) {
      return getDuration(date)
    }
  },
  mounted() {
    this.coursesCount = this.agent.courses.length
    this.interactions = 0
    this.attempts = 0

    let agentCoursesCopy = Object.assign([], this.agent.courses)
    agentCoursesCopy.forEach(element => {
      this.interactions += parseInt(element.interactionsCount)
      this.attempts += parseInt(element.attempts)

      if (this.lastInteraction == null) {
        this.lastInteraction = moment(element.timestamp)
      } else {
        if (moment(element.lastInteraction).isAfter(this.lastInteraction)) {
          this.lastInteraction = moment(element.lastInteraction)
        }
      }

      if (element.timeSpent) {
        if (this.timeSpent) {
          this.timeSpent = moment
            .duration(element.timeSpent)
            .add(this.timeSpent)
        } else {
          this.timeSpent = moment.duration(element.timeSpent)
        }
      }
    })
    this.lastInteraction = moment(this.lastInteraction).format('MM/DD/YYYY')
  }
}
</script>

<style></style>
